module.exports = __webpack_public_path__ + "static/media/profile-call-correct.3242a500.png";